import { Button } from 'react-bootstrap'
import { useState, useRef } from 'react'
import emailjs from '@emailjs/browser'
import './App.css'

export default function ContactPage({ navigate }) {
    const form = useRef();
    const [status, setStatus] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault(); // no page reload please
        setStatus("Sending...");
        emailjs.sendForm(
            process.env.REACT_APP_MY_ID,
            process.env.REACT_APP_MY_TEMPLATE_ID,
            form.current,
            process.env.REACT_APP_MY_PUBLIC_KEY
        ).then(() => {
            setStatus("Message sent!");
            form.current.reset();
        }).catch(() => {
            setStatus("Failed to send message.");
        });
    }

    return (
        <div className="contact-root" style={styles.main}>
            <div style={styles.grid}>
                <div>
                    <h1>contact me</h1>
                    <p>feel free to chat with me about anything - be it work, music, or just to say hi!</p>
                </div>
                <form ref={form} onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <div style={{ marginTop: '1rem' }}>
                            <label htmlFor="name" style={{ marginRight: '1rem' }}>your name</label>
                            <input type="text" id="name" name="name" required />
                        </div>
                        <div style={{ marginTop: '1rem' }}>
                            <label htmlFor="email" style={{ marginRight: '1rem' }}>email</label>
                            <input type="email" id="email" name="email" required />
                        </div>
                        <div style={{ marginTop: '1rem' }}>
                            <label htmlFor="message" style={{ marginRight: '1rem' }}>message</label>
                            <textarea id="message" name="message" required />
                        </div>
                    </div>
                    <Button type="submit"
                        style={{ ...styles.btn, backgroundColor: '#cfeaecff' }}>
                        send email
                    </Button>
                    <p style={{ marginTop: '1rem' }}>{status}</p>

                </form>
                <Button onClick={navigate} aria-label="return to welcome page"
                    style={styles.btn} onMouseOver={e => {
                        e.currentTarget.style.backgroundColor = '#f4acb7';
                    }} onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#F6CFD6';
                    }}>
                    return to welcome page
                </Button>
            </div>
        </div>
    )
}
const styles = {
    main: {
        border: '0.625rem solid #cfeaecff',
        padding: '3.125rem',
        borderRadius: '1.5625rem',
        minHeight: '100vh',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        boxSizing: 'border-box',
        backgroundColor: '#fff9faff',
    },
    grid: {
        display: 'flex',
        gridTemplateColumns: 'minmax(7.5rem, 18%) 1fr minmax(15rem, 30%)',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 0,
        width: '100%',
        maxWidth: '68.75rem',
    },
    btn: {
        marginTop: '1.25rem',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#000000ff',
        backgroundColor: '#F6CFD6',
        border: 'none',
    },
}